import React, { useState } from "react";
import styled from "styled-components";
import { cryptoType, gameType, useApp } from "../../../../../contexts";
import {
  FormItem,
  FormSelect,
  FormButton,
} from "../../../../../components/Form";
import { getValueByTab } from "..";
import FormButton2 from "../../../../../components/FormCustom2/Button";
import FormInput from "../../../../../components/FormCustom2/Input";
import { DatePickerViewMobile } from "../../../../../components/DatePicker/mobile";

import moment from "moment";
import {
  statusFilterTransaction1,
  statusFilterTransaction2,
  typeBalanceOptions,
  typeTransactionOptions,
} from "../../../../../constants";
import StatusItem from "../StatusItem";
import produce from "immer";
import { isSOTd } from "../../../../../utils/helper";

const ModalWraper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  & .contentFilter {
    position: absolute;
    background: #f5f5f5;
    border-radius: 32px 32px 0px 0px;
    left: 0;
    right: 0;
    bottom: 0;
    height: 90%;
    z-index: 11;
    padding: 29px 16px 26px 16px;

    & .title {
      display: block;
      width: 101px;
      margin: 0 auto;
      font-weight: 700;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      color: #000000;
    }

    .ant-form-item-label {
      font-weight: 400;
      font-size: 15px;
      line-height: 25px;
      color: #818181;
      padding-bottom: 4px;
      & > label {
        height: unset;
      }
    }
    .ant-select-single .ant-select-selector {
      height: 50px !important;
    }
  }
`;

const ModalFilter = ({
  tab = "crypto",
  onClose,
  queryTabValue,
  setQuery,
  setDatePicker,
  handleChangeTime,
  fieldTabName,
  code,
  onSearch,
  onReset,
}) => {
  const { T, currencies, user } = useApp();
  const [isDatePicker, setIsDatePicker] = useState(false);
  return (
    <ModalWraper onClick={onClose}>
      <div
        className="contentFilter"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <span className="title">{T("Filter")}</span>
        <div className="flex flex-col justify-between h-[93.2%]">
          <div className=" overflow-auto">
            <FormItem label={T("Time")}>
              <DatePickerViewMobile
                fromDate={queryTabValue.fromDate}
                toDate={queryTabValue.toDate}
                onCancel={() => {
                  setIsDatePicker(false);
                }}
                onChange={(event) => {
                  setQuery(
                    produce((draft) => {
                      draft[fieldTabName].fromDate = event.fromDate
                        .startOf("day")
                        .toDate()
                        .getTime();
                      draft[fieldTabName].toDate = event.toDate
                        .endOf("day")
                        .toDate()
                        .getTime();
                    })
                  );
                  setIsDatePicker(false);
                }}
              />
            </FormItem>
            <FormItem label={T("Type")}>
              <FormSelect
                allowClear={false}
                value={queryTabValue?.types ?? ""}
                onChange={(value) =>
                  setQuery(
                    produce((draft) => {
                      draft[fieldTabName].types = value == "" ? value : [value];
                    })
                  )
                }
              >
                {typeBalanceOptions(tab, code, user.country_code).map(
                  (type, index) => (
                    <FormSelect.Option
                      key={index.toString()}
                      value={type.value}
                    >
                      {T(type.label).replace("{currency_code}", code)}
                    </FormSelect.Option>
                  )
                )}
              </FormSelect>
            </FormItem>

            <FormItem label={T("Transaction ID")}>
              <FormInput
                value={queryTabValue?.keyword}
                onChange={(value) =>
                  setQuery(
                    produce((draft) => {
                      draft[fieldTabName].keyword = value.target.value;
                    })
                  )
                }
                placeholder={T("Please enter Transaction ID")}
              />
            </FormItem>
          </div>
          <div className="flex gap-[15px]">
            <FormButton2
              style={{ width: "50%" }}
              className="black2"
              height={52}
              width={164}
              onClick={onReset}
            >
              {T("Reset")}
            </FormButton2>
            <FormButton2
              height={52}
              className="black"
              onClick={() => onSearch()}
              style={{ minWidth: 164 }}
            >
              {T("Search")}
            </FormButton2>
          </div>
        </div>
      </div>
    </ModalWraper>
  );
};
export default ModalFilter;
